import {
  faTrees,
  faBullseyeArrow,
  faHandHoldingSeedling,
  faFire,
  faLeafOak,
  faBee,
  faDeer,
  faMap,
  faImageLandscape,
  faCarSide,
  faBridgeWater,
  faCloudShowersWater,
  faHouseTsunami,
  faBlueberries,
  faSeedling,
  faHouseChimneyHeart,
  faFlowerDaffodil,
  faHandsHoldingHeart,
  faTrillium,
  faRoad,
  faChair,
  faChartScatterBubble,
  faTree,
  faRaccoon,
  faBinoculars,
} from "@fortawesome/pro-duotone-svg-icons"

export const ACTION_ICON = {
  "Timber Management / Forest Stand Improvement": faTrees,
  "Establish a Forest Management Plan": faBullseyeArrow,
  "Improve and Sustain Forest Health and Productivity": faHandHoldingSeedling,
  "Reduce Fire Risk and Hazard and Facilitate Prescribed Burning": faFire,
  "Facilitate Oak Regeneration": faLeafOak,
  "Wildlife and Pollinator Habitat": faBee,
  "Wildlife Habitat for Deer": faDeer,
  "Trail Access & User Experience": faMap,
  "Scenic Beauty & Natural Aesthetics": faImageLandscape,
  "Access Infrastructure & Trail Development": faCarSide,
  "Site Protection & Erosion Control": faBridgeWater,
  "Carbon Market & Sequestration Opportunities": faCloudShowersWater,
  "Cover and Shelter Improvements": faHouseTsunami,
  "Enhance Food Sources": faBlueberries,
  "Foundational Forest Health & Resilience": faSeedling,
  "Habitat Structure & Cover Enhancement": faHouseChimneyHeart,
  "Landscape Planning & Long-Term Conservation": faFlowerDaffodil,
  "Ongoing Conservation Stewardship": faHandsHoldingHeart,
  "Restoration & Risk Reduction": faTrillium,
  "Road Functionality and Safety": faRoad,
  "Specialty Forest Products & Habitat-Linked Income": faChair,
  "Strategic Habitat Planning": faChartScatterBubble,
  "Timber Production & Forest Value Improvement": faTree,
  "Wildlife Food Resources": faRaccoon,
  "Wildlife Viewing": faBinoculars,
}

export const govtWizardNextStepsCardLinks = [
  <a
    href="https://www.farmers.gov/sites/default/files/documents/farmersgov-form-ad-2047.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="link font-normal"
    key="Form AD 2047"
  >
    Form AD 2047
  </a>,
  <a
    href="https://www.farmers.gov/sites/default/files/documents/form-ad1026-highly-erodible-land.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="link font-normal"
    key="Highly Erodible Lands and Wetlands Provisions"
  >
    Highly Erodible Lands and Wetlands Provisions
  </a>,
  <a
    href="https://www.farmers.gov/sites/default/files/documents/CCC-941.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="link font-normal"
    key="verage Adjusted Gross Income Certification and Consent to Disclosure of Tax Information"
  >
    Average Adjusted Gross Income Certification and Consent to Disclosure of Tax
    Information
  </a>,
  <a
    href="https://www.farmers.gov/sites/default/files/forms/farmersgov-ccc902i-farm-operating-plan-individuals-01-07-2021.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="link font-normal"
    key="Farm Operating Plan"
  >
    Farm Operating Plan
  </a>,
  <a
    href="https://www.farmers.gov/sites/default/files/documents/ccc0901-210107v02.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="link font-normal"
    key="Member's Information Form"
  >
    Member's Information Form
  </a>,
  <a
    href="https://www.farmers.gov/sites/default/files/forms/farmersgov-form-ccc-socially-disadvantaged-cert-860-1-11-23.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="link font-normal"
    key="Socially Disadvantaged"
  >
    Socially Disadvantaged, Limited Resource, and Beginning and Veteran Farmer
    or Rancher Certification
  </a>,
]
